import { DraftStatus } from "authoring/lib/enum/draft-status.mjs"

export function isSendToLegacyBlockingSchedule(schedule) {
    if (!schedule?.isDraft) return true
    return schedule?.status !== DraftStatus.APPROVED
}
